import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { ModalController } from '@ionic/angular';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { Subscription } from 'rxjs/internal/Subscription';
import { DocTypeView } from 'src/app/models/docTypeView.model';
import { User } from 'src/app/models/user.model';
import { ApiService } from 'src/app/services/api.service';
import { AssetDocumentsComponent } from '../asset-documents/asset-documents.component';
import { Client } from 'src/app/models/client.model';
import { PersistedValueEnum } from 'src/app/models/persisted-value-enum';
import { AirAdPage } from 'src/app/pages/statuslists/air-ad/air-ad.page';
import { PageSettingsModel, TextWrapSettingsModel, EditSettingsModel, FilterSettingsModel, GridComponent } from '@syncfusion/ej2-angular-grids';

@Component({
  selector: 'oil-event',
  templateUrl: './oil-event.component.html',
  styleUrls: ['./oil-event.component.scss'],
})
export class OilEventComponent implements OnInit {
  public isSaving = false;
  @Input() type: 'Edit' | 'Add';
  @Input() event: any;
  @Input() assetObj: any = null;

  @ViewChild('tabContainer', { static: false }) tabContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('eventCategory') public grid: GridComponent;
  eventId: string;
  asset: string = '';
  assets: any[] = [
    { name: 'Aircraft', id: 1 },
    { name: 'Engine', id: 2 },
    { name: 'APU', id: 3 },
    { name: 'Landing Gear', id: 4 },
    { name: 'Propeller', id: 5 },
    // { name: 'Component', id: 6 },
  ];
  eventType: string = '';
  eventTypes: string[] = [];
  description: string = '';
  eventUsers: string[] = [];
  // separatorKeysCodes: number[] = [ENTER, COMMA];
  // selectedUsers: any[] = [];
  users: any[] = [];
  selectedUsersForApproval: any[] = [];
  assetsList: any[] = [];
  eventAssetsList: any[] = [];
  // filteredAssetsList: any[] = [];
  // filteredUsersList: any[] = [];
  alreadyAssignedUser: any[] = []; // stores only IDs
  allAssetsBasedOnAssetType: any[] = [];
  msnLoading: boolean = true;
  searchedUserLoading: boolean = true;
  userId: string = '';
  userSub: Subscription;
  sub: Subscription;
  awdbSub: Subscription;
  eventForm: FormGroup;
  status: any = ['OPEN', 'CLOSED'];
  // user:any
  clientID = localStorage.getItem('client') ? JSON.parse(localStorage.getItem('client'))?.clientID : null;
  @ViewChild('autoInput') autoInput: ElementRef<HTMLInputElement>;
  @ViewChild('autoInputUser') autoInputUser: ElementRef<HTMLInputElement>;
  @ViewChild('trigger', { read: MatAutocompleteTrigger }) autocompleteTrigger!: MatAutocompleteTrigger;
  @ViewChildren('tooltipRef') tooltips: QueryList<any>;
  @ViewChildren('userTooltipRef') userTooltipRef: QueryList<any>;
  editableForm: boolean = true;
  permissionmodelopen: boolean;

  gridColumns: any[] = [];
  canScrollLeft = false;
  canScrollRight = true;
    selectedEventCategoryData: any;
    selectedEventCategoryAssetId: any;
  expandedRowIndex: number | null = null;
   nodeState: any[] = [];
   taskListState: any[] = [];
   public docTypeViewList: DocTypeView[] = [];
documentTypeList: any[] = [];
documentTypeFields: Object;
public docTypeSub: Subscription;
public client: Client;
taskList: any = null;
public pageSettings: PageSettingsModel;
  public wrapSettings: TextWrapSettingsModel;
  public editSettings: EditSettingsModel;
  public filterOption: FilterSettingsModel = { type: 'Menu' };
  constructor(
    private apiService: ApiService,
    private modalController: ModalController,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.client = JSON.parse(localStorage.getItem(PersistedValueEnum.client));
    this.eventForm = new FormGroup({
      title: new FormControl('', [Validators.required]),
      assetTypeId: new FormControl(this.assets[0]?.id, [Validators.required]),
      assetId: new FormControl('', [Validators.required]),
      description: new FormControl(''),
      users: new FormControl([], [Validators.required]),
      approvalUserIds: new FormControl([], [Validators.required]),
      status: new FormControl('OPEN'),
    });
    if (this.assetObj) {
      this.eventForm.patchValue({
        assetTypeId: this?.assetObj?.assetTypeId,
      });
    }
    if (this.event !== null) {
      this.setForm();
    }
    this.getAssetsList();
    this.getUsers();
    this.syncApprovalUsers();
  }

  public setForm(): void {
    if (this.event) {
      this.eventForm = new FormGroup({
        title: new FormControl(this.event?.title, [Validators.required]),
        assetTypeId: new FormControl(this.event?.assetTypeId, [Validators.required]),
        assetId: new FormControl('', [Validators.required]),
        description: new FormControl(this.event?.description),
        users: new FormControl([], [Validators.required]),
        approvalUserIds: new FormControl([], [Validators.required]),
        id: new FormControl(this.event?.id),
        status: new FormControl(this.event.status),
      });
      // const idsList = this.event?.assigned_users?.map((ua: any) => ua?.userId);
    }
  }

  closeDialog() {
    this.modalController.dismiss({
      dismissed: false,
    });
  }

  formatUserDisplay(user: any): string {
    if (!user) return '';
    // let parts = ['User Name: ' + user?.firstName + ' ' + user?.lastName, '|| Email:' + user?.email];
    let parts = [user?.firstName + ' ' + user?.lastName];
    return parts.join(' ');
  }
  public getUsers(): void {
    let data = {
      userId: 'all',
      clientID: this.clientID,
      // filter,
    };
    this.searchedUserLoading = true;
    this.userSub = this.apiService.getUser(data).subscribe(
      (res: User[]) => {
        //console.log(res);
        this.users = res;

        if (this.event) {
          const assignedUserIds = this.event?.assigned_users?.map((ua: any) => ua?.userId);
          const approveUserIds = this.event?.approval_user?.map((ua: any) => ua?.userId);
          this.eventForm.get('users')?.setValue(assignedUserIds);
          this.selectedUsersForApproval = this.users.filter((u) => this.eventForm.value.users.includes(u.id));
          this.eventForm.get('approvalUserIds')?.setValue(approveUserIds);
        }
        this.searchedUserLoading = false;
      },
      (err) => {
        this.searchedUserLoading = false;
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
      },
    );
    (err) => {
      this.searchedUserLoading = false;
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    };
  }
  private syncApprovalUsers() {
    const usersCtrl = this.eventForm.get('users');
    const approvalCtrl = this.eventForm.get('approvalUserIds');

    usersCtrl!.valueChanges.subscribe((selectedUserIds: number[]) => {
      if (!Array.isArray(selectedUserIds)) {
        selectedUserIds = [];
      }

      // 1️⃣ Filter full users list → only selected users
      this.selectedUsersForApproval = this.users.filter((user) => selectedUserIds.includes(user.id));

      // 2️⃣ Remove approval users that were unchecked in Users
      const validApprovalUsers = (approvalCtrl!.value || []).filter((id) => selectedUserIds.includes(id));

      // 3️⃣ Update approval control safely
      approvalCtrl!.setValue(validApprovalUsers, {
        emitEvent: false,
      });
    });
  }
  // selected(event: MatAutocompleteSelectedEvent): void {
  //   const user = event.option.value;
  //   if (!this.selectedUsers.some((r) => r?.id === user?.id)) {
  //     this.selectedUsers.push({ eventSavedDBUsers: false, ...user });
  //     const userIds = this.selectedUsers.map((r) => r?.id);
  //     this.eventForm.get('users')?.setValue(userIds);
  //   }

  //   // this.autoInput.nativeElement.value = '';
  //   const selectedFilteredAssetsList = this.users.filter(
  //     (allUser) => !this.selectedUsers.some((selectedUser) => selectedUser?.id === allUser?.id)
  //   );
  //   this.filteredUsersList = selectedFilteredAssetsList;

  //   this.userTooltipRef.forEach((tooltip) => {
  //     tooltip.close(); // Or tooltip.hide() depending on ejs-tooltip API
  //   });
  // }
  // userSearchedVlaue: any = '';
  // onInputChange(event: any): void {
  //   this.userSearchedVlaue = event?.target?.value?.toLowerCase() || '';
  //   // this.filteredItems = this.taskIdList.filter((item) => this.getItemLabel(item).toLowerCase().includes(searchValue));

  // }
  // getSearchedUsers() {
  //   if (this.userSearchedVlaue) {
  //     this.getUsers({ name: 'filter', value: this.userSearchedVlaue });
  //   }
  // }
  // add(event: MatChipInputEvent): void {
  //   const value = (event?.value || '').trim();
  //   // Add the value only if it's not empty
  //   if (value) {
  //     const existing = this.users.find((user) => user?.id === value);
  //     if (existing && !this.selectedUsers.includes(existing)) {
  //       this.selectedUsers.push({ eventSavedDBUsers: false, ...existing });
  //     }
  //   }

  //   // Clear the input value
  //   event.chipInput!.clear();

  //   // Update the form control (optional)
  // }
  public ngOnDestroy(): void {
    if (this.userSub !== null && this.userSub !== undefined) {
      this.userSub.unsubscribe();
    }
    if (this.sub !== null && this.sub !== undefined) {
      this.sub.unsubscribe();
    }
    if (this.awdbSub !== null && this.awdbSub !== undefined) {
      this.awdbSub.unsubscribe();
    }
    if (this.docTypeSub !== null && this.docTypeSub !== undefined) {
      this.docTypeSub.unsubscribe();
    }
  }
  toggleEditableForm(): void {
    this.editableForm = true;
  }
  isDisabled(): boolean {
    return this.event ? this.editableForm : false;
  }
  // getSelectedRoleIds(): number[] {
  //   return this.selectedUsers.map((user) => user.id);
  // }
  // public statusListDialogObj;
  //   public onOpenUserAssetsAccessDeleteDialog = function (user): void {
  //     this.user = user
  //     this.statusListDialogObj = DialogUtility.confirm({
  //       title: 'Removal Confirmation',
  //       content: 'Remove selected user from the event?',
  //       okButton: { text: 'OK', click: this.deleteUserAssetsAccess.bind(this) },
  //       cancelButton: { text: 'Cancel', click: this.cancelUserAssetsAccessClick.bind(this) },
  //       showCloseIcon: true,
  //       closeOnEscape: true,
  //       animationSettings: { effect: 'Zoom' },
  //     });
  //   };

  //   private deleteUserAssetsAccess(): void {
  //     this.removeRole(this.user)
  //     this.statusListDialogObj.hide();
  //   }

  //   private cancelUserAssetsAccessClick(): void {
  //     //Hide the dialog
  //     this.statusListDialogObj.hide();
  //   }
  // removeRole(user: any): void {
  //   const index = this.selectedUsers.indexOf(user);
  //   if (index >= 0) {
  //     this.selectedUsers.splice(index, 1);
  //   }
  //   const assetRoleIds = this.selectedUsers.map((r) => r?.id);
  //   this.eventForm.get('users')?.setValue(assetRoleIds);
  //   this.filteredUsersList = this.users.filter(
  //     (allUsers) => !this.selectedUsers.some((selectedAssets) => selectedAssets?.id === allUsers?.id)
  //   );
  // }
  assetSelectValueEmpty() {
    // this.filteredAssetsList = [];
    this.assetsList = [];
    this.eventForm.get('assetId').setValue(null);
    this.msnLoading = true;
    this.getAssetsList();
  }
  getAssetsList() {
    // this.filteredAssetsList = [];
    this.assetsList = [];
    const assetTypeId = this.eventForm.get('assetTypeId').value;
    const data = {
      page: 1,
      limit: 10000,
      // filter,
      // is_installed: false,
    };
    try {
      this.msnLoading = true;
      if (assetTypeId === 1) {
        this.cdr.detectChanges();
        ((this.sub = this.apiService.getAircraftByClientId(data).subscribe(
          (airData: any) => {
            this.assetsList = airData?.data ? airData?.data : [];
            // this.filteredAssetsList = this.assetsList;
            this.msnLoading = false;
            if (this.event || this.assetObj) {
              this.eventForm.patchValue({ assetId: this.event?.assetId || this.assetObj?.assetId });
            }
            this.cdr.detectChanges();
          },
          (err) => {
            this.msnLoading = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null,
            );
          },
        )),
          (err) => {
            this.msnLoading = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null,
            );
          });
      }
      if (assetTypeId === 2) {
        this.cdr.detectChanges();
        ((this.sub = this.apiService.getEngineByClientId(data).subscribe(
          (engData: any) => {
            this.assetsList = engData?.data ? engData?.data : [];
            this.msnLoading = false;
            if (this.event || this.assetObj) {
              this.eventForm.patchValue({ assetId: this.event?.assetId || this.assetObj?.assetId });
            }
          },
          (err) => {
            this.msnLoading = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null,
            );
          },
        )),
          (err) => {
            this.msnLoading = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null,
            );
          });
      }

      if (assetTypeId === 3) {
        this.cdr.detectChanges();
        ((this.sub = this.apiService.getApuByClientId(data).subscribe(
          (apuData: any) => {
            this.assetsList = apuData?.data ? apuData?.data : [];
            this.msnLoading = false;
            if (this.event || this.assetObj) {
              this.eventForm.patchValue({ assetId: this.event?.assetId || this.assetObj?.assetId });
            }
          },
          (err) => {
            this.msnLoading = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null,
            );
          },
        )),
          (err) => {
            this.msnLoading = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null,
            );
          });
      }

      if (assetTypeId === 4) {
        this.cdr.detectChanges();
        ((this.sub = this.apiService.getLandingGearByClientId(data).subscribe(
          (lgData: any) => {
            this.assetsList = lgData?.data ? lgData?.data : [];
            this.msnLoading = false;
            if (this.event || this.assetObj) {
              this.eventForm.patchValue({ assetId: this.event?.assetId || this.assetObj?.assetId });
            }
          },
          (err) => {
            this.msnLoading = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null,
            );
          },
        )),
          (err) => {
            this.msnLoading = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null,
            );
          });
      }

      if (assetTypeId === 5) {
        this.cdr.detectChanges();
        ((this.sub = this.apiService.getPropByClientId(data).subscribe(
          (propData: any) => {
            this.assetsList = propData?.data ? propData?.data : [];
            this.msnLoading = false;
            if (this.event || this.assetObj) {
              this.eventForm.patchValue({ assetId: this.event?.assetId || this.assetObj?.assetId });
            }
          },
          (err) => {
            this.msnLoading = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null,
            );
          },
        )),
          (err) => {
            this.msnLoading = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null,
            );
          });
      }

      // if (assetTypeId === 6) {
      //   (this.sub = this.apiService.getUninstalledComponent(data).subscribe(
      //     (data: any) => {
      //       this.assetsList = data ? data?.data : [];
      //       // this.filteredAssetsList = this.assetsList;
      //       this.msnLoading = false;
      //       if (this.event || this.assetObj) {
      //          this.eventForm.patchValue({ assetId: this.event?.assetId || this.assetObj?.assetId });
      //       }
      //       // let componentsList = data.body

      //       // for (let i in componentsList) {
      //       //   const component = componentsList[i];

      //       //   // Check if the ID exists in this.asset.components
      //       //   const isDuplicate = this.asset?.components.some(
      //       //     (assetComponent) => assetComponent?.id === component?.id
      //       //   );

      //       //   // Only push if there is no match
      //       //   if (!isDuplicate) {
      //       //     this.componentList.push(component);
      //       //     this.assetsList.push(component.serialNumber);
      //       //   }
      //       // }
      //     },
      //     (err: any) => {
      //       this.msnLoading = false;
      //       this.apiService.openErrorSnackBar(
      //         err?.error?.error ? err?.error?.error : 'Please contact support team',
      //         null
      //       );
      //     }
      //   )),
      //     (err: any) => {
      //       this.msnLoading = false;
      //       this.apiService.openErrorSnackBar(
      //         err?.error?.error ? err?.error?.error : 'Please contact support team',
      //         null
      //       );
      //     };
      // }
    } catch (err) {
      this.msnLoading = false;
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    }
  }

  getItemLabel(item: any): string {
    if (!item || this.assetsList?.length === 0) return '';
    const assetTypeId = this.eventForm.get('assetTypeId').value;
    if (assetTypeId?.toString() === '1') {
      return 'Serial Number: ' + item?.msn + ' || Model: ' + (item?.model || '');
    }
    if (assetTypeId?.toString() === '2') {
      return 'Serial Number: ' + item?.esn + ' || Model: ' + (item?.model || '');
    }

    if (assetTypeId?.toString() === '4') {
      return (
        'Serial Number: ' +
        item?.serialNumber +
        ' || Model: ' +
        (item?.model || '') +
        ' || Part Number: ' +
        (item?.partNumber || '')
      );
    }
    if (assetTypeId?.toString() === '6') {
      return 'Serial Number: ' + item?.serialNumber + ' || Part Number: ' + (item?.component_profile?.partNumber || '');
    }

    return 'Serial Number: ' + item?.serialNumber + ' || Part Number: ' + (item?.partNumber || '');
  }
  // displayFn = (id: any): string => {
  //   if (!id) return '';
  //   const item = this.assetsList?.find((x) => x.id == id);
  //   return this.getItemLabel(item);
  // };
  // onOptionSelected() {
  //   this.tooltips.forEach((tooltip) => {
  //     tooltip.close(); // Or tooltip.hide() depending on ejs-tooltip API
  //   });
  // }
  // assetTypeValueSelected(option: any) {
  //     return this.eventForm.get('assetTypeId').value?.toString() === '2' ? option?.esn : this.eventForm.get('assetTypeId').value?.toString() === '1' ? option?.msn : option?.serialNumber;
  //   }
  // searchValue: any;
  // onInputAssetChange(event: any): void {
  //   this.searchValue = event?.target?.value?.toLowerCase() || '';
  //   console.log(this.searchValue)
  //   // this.filteredItems = this.taskIdList.filter((item) => this.getItemLabel(item).toLowerCase().includes(searchValue));
  //   if (this.filteredAssetsList?.length === 0) {
  //     this.msnLoading = true;
  //   }
  // }
  // getAssets() {
  //   console.log(this.searchValue)
  //   if (this.searchValue) {
  //     this.getUninstalledAssetsList({ name: 'filter', value: this.searchValue });
  //   }
  // }

  public submit(): void {
    if (this.eventForm.invalid) {
      this.eventForm.markAllAsTouched();
      return;
    }

    this.isSaving = true;
    this.EventApiCall();
  }

  public EventApiCall(): void {
    try {
      var obj: any;

      obj = {
        assetTypeId: this.eventForm.get('assetTypeId')?.value,
        assetId: this.eventForm.get('assetId').value,
        title: this.eventForm.get('title')?.value,
        description: this.eventForm.get('description')?.value,
        assignUserIds: this.eventForm.get('users')?.value,
        approvalUserIds: this.eventForm.get('approvalUserIds')?.value,
        status: this.eventForm.get('status')?.value,
        documentExclusions:this.nodeState,
        taskListExclusions:this.taskListState
      };
      console.log(obj);

      // if create for status list
      if (this.event === null) {
        obj['status'] = 'OPEN';
        let data = {
          recordObj: obj,
        };
        ((this.sub = this.apiService.addEvent(data).subscribe(
          (res: any) => {
            if (res !== null) {
              this.apiService.openSnackBar('Data Created Successfully');
              this.eventForm.reset();
              this.modalController.dismiss({
                dismissed: true,
              });
              this.isSaving = false;
            }
          },
          (err: any) => {
            this.isSaving = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null,
            );
          },
        )),
          (err: any) => {
            this.isSaving = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null,
            );
          });
      }
      // update for status list
      else {
        obj['id'] = Number(this.event?.id);
        delete obj['assetTypeId'];
        delete obj['assetId'];
        let data = {
          recordObj: obj,
        };
        ((this.sub = this.apiService.updateEvent(data).subscribe(
          (res: any) => {
            if (res !== null) {
              this.apiService.openSnackBar('Data Updated Successfully');
              this.eventForm.reset();
              this.modalController.dismiss({
                dismissed: true,
              });
            }

            this.isSaving = false;
          },
          (err: any) => {
            this.isSaving = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null,
            );
          },
        )),
          (err: any) => {
            this.isSaving = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null,
            );
          });
      }
    } catch (err) {
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    }
  }
  // saveAssignedUserIds(assignedUserIdsList: any): void {
  //   // Step 1: Extract userIds from event.userAssigned

  //   // Step 2: Filter users from DB by those IDs
  //   this.selectedUsers = this.alreadyAssignedUser = this.users
  //     .filter((user) => assignedUserIdsList?.includes(user?.id))
  //     .map((user) => ({ ...user, eventSavedDBUsers: true }));

  //   this.filteredUsersList = this.users
  //     .filter((user) => !assignedUserIdsList?.includes(user?.id))
  //     .map((user) => ({ ...user, eventSavedDBUsers: false }));
  // }
  // assignedUserDisabled(id: any): boolean {
  //   return this.event?.assigned_users?.some((ua: any) => ua?.userId === id) ?? false;
  // }

  onTabSelect(data) {
    this.permissionmodelopen = false;
    if (data?.selectedIndex === 0) {
      this.getAssetsList();
      this.getUsers();
      this.syncApprovalUsers();
    } else if (data?.selectedIndex === 1) {
      this.permissionmodelopen = true;
    }
  }

  onCategoryChange() {
  if (this.selectedEventCategoryData?.assetType) {
    this.buildColumns(this.selectedEventCategoryData.assetType);
  }
}

buildColumns(assetType: string) {
  const cols: any[] = [];

  if (assetType !== 'Component') {
    cols.push({ field: 'make', headerText: 'Make', width: 200 });
  }

  if (assetType === 'Engine' || assetType === 'APU') {
    cols.push({ field: 'model', headerText: 'Model', width: 200 });
  }

  if (assetType === 'Component') {
    cols.push(
      { field: 'ataChapter', headerText: 'ATA Chapter', width: 200 },
      { field: 'category', headerText: 'Category', width: 200 },
      { field: 'nomenclature', headerText: 'Nomenclature', width: 200 }
    );
  }

  if (
    assetType === 'Landing Gear' ||
    assetType === 'Propeller' ||
    assetType === 'Component'
  ) {
    cols.push({ field: 'partNumber', headerText: 'Part Number', width: 200 });
  }

  cols.push({ field: 'serialNumber', headerText: 'Serial Number', width: 200 });

  this.gridColumns = cols;
}

  selectEventCategory(event: any) {
    this.selectedEventCategoryData = event;
    this.expandedRowIndex = null;
    if(!this.selectedEventCategoryData?.data){
      this.selectedEventCategoryAssetId =  this.selectedEventCategoryData?.id
      this.getDocTypeView(this.selectedEventCategoryAssetId,this.getAssetObj(this.selectedEventCategoryData?.assetType))
    }
    this.onCategoryChange();
    // this.getTaskListView();
  }

  scrollTabs(direction: 'left' | 'right') {
    if (!this.tabContainer) return; // prevent errors
    const container = this.tabContainer.nativeElement;
    const scrollAmount = 200;
    const scrollBy = direction === 'left' ? -scrollAmount : scrollAmount;
    container.scrollBy({ left: scrollBy, behavior: 'smooth' });
    this.cdr.detectChanges()
  }

  checkScrollArrows(container: HTMLElement) {
    this.canScrollLeft = container.scrollLeft > 0;
    this.canScrollRight = container.scrollLeft < container.scrollWidth - container.clientWidth - 10;
    this.cdr.detectChanges()
  }

  formatAssetType(type: string): string {
    return type.replace(/([a-z])([A-Z])/g, '$1 $2');
  }
  flattenAssets(data) {
    const main = data.map((a: any) => ({
      assetType: a.assetType,
      id: a.id,
      serialNumber: a.serialNumber,
      isEventCreator: a?.isEventCreator,
    }));

    const attachments = data.flatMap((a: any) =>
      a.assetAttach.map((child: any) => ({
        assetType: child.assetType,
        data: child.data || [],
      }))
    );

    this.eventAssetsList = [...main, ...attachments].filter(
      (a) => a.data?.length > 0 || !a.data
    );

    console.log(this.eventAssetsList)
    // Select first tab by default
    this.selectEventCategory(this.eventAssetsList[0])
  }

  public getOilEventDashboardData(assetId:any,assetTypeId:any): void {
    this.eventAssetsList = [];
    try {
      (this.awdbSub = this.apiService.getOilEventCategoryData(null,{assetId,assetTypeId}).subscribe(
        (res: any) => {
          const data = res.map((item: any) => {
            const attached = item.attachedAssets || {};

            const assetAttach = Object.keys(attached).map((key) => {
              const data = (attached[key] || []).map((a: any) => {
                if(this.formatAssetType(key) === 'Engine' || this.formatAssetType(key) === 'APU'){
                  return {
                  assetType: this.formatAssetType(key),
                  id: a.id,
                  serialNumber: a.serialNumber,
                  isEventCreator: a?.isEventCreator,
                  make:a?.make,
                  model:a?.model
                }
                }
                else if(this.formatAssetType(key) === 'Landing Gear' || this.formatAssetType(key) === 'Propeller'){
                  return {
                  assetType: this.formatAssetType(key),
                  id: a.id,
                  serialNumber: a.serialNumber,
                  isEventCreator: a?.isEventCreator,
                  make:a?.make,
                  partNumber:a?.partNumber
                }
                }
                else if(this.formatAssetType(key) === 'Component'){
                  return {
                  assetType: this.formatAssetType(key),
                  id: a.id,
                  serialNumber: a.serialNumber,
                  isEventCreator: a?.isEventCreator,
                  nomenclature:a?.nomenclature,
                  category:a?.category,
                  ataChapter:a?.ataChapter,
                  partNumber:a?.partNumber
                }
                }
                return {
                assetType: this.formatAssetType(key),
                id: a.id,
                serialNumber: a.serialNumber,
                isEventCreator: a?.isEventCreator,
                make:a?.make,
                model:a?.model
                }

              });

              return {
                assetType: this.formatAssetType(key),
                data,
              };
            });
            return {
              assetType: item.assetType,
              id: item.id,
              serialNumber: item.serialNumber,
              isEventCreator: item?.isEventCreator,
              assetAttach,
            };
          });
          console.log(data)
          this.flattenAssets(data)
          this.cdr.detectChanges()
        },
        (err) => {
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        }
      )),
        (err) => {
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        };
    } catch (err) {
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    }
  }
  // ✅ Helper: get or create asset state
  getAssetState(assetId: string, assetTypeId: string) {
    let assetObj = this.nodeState.find(
      (x) => x.assetId === assetId && x.assetTypeId === assetTypeId
    );

    if (!assetObj) {
      assetObj = {
        assetId,
        assetTypeId,
        includeFolderNodeIds: [],
        excludeFolderNodeIds: []
      };
      this.nodeState.push(assetObj);
    }

    return assetObj;
  }

  // ✅ MAIN TREE CHECK EVENT
  onNodeChecked(args: any) {
    const nodeData = args.data;

    nodeData.forEach((node: any) => {
      const nodeId = node.id;
      const isChecked = node.isChecked === 'true';

      this.updateCheckedArrays(nodeId, isChecked);

      if (node.hasChildren && isChecked) {
        this.checkAllChildren(node, true);
      }

      if (node.parentID && isChecked) {
        this.checkParent(node.parentID, nodeData);
      }
    });

    console.log('Node State:', this.nodeState);
  }

  // ✅ CUSTOM CHECKBOX HANDLER
  onCustomCheck(node: any, event: any) {
    const isChecked = event.checked ?? event.checked;
    node.show_in_oil = isChecked;

    this.updateCheckedArrays(node.id, isChecked);

    if (node.subChild && node.subChild.length > 0) {
      this.checkAllChildren(node, isChecked);
    }

    if (node.parentId) {
      this.updateParentState(node.parentId, this.docTypeViewList);
    }

    console.log('Node State:', this.nodeState);
  }

  // ✅ UPDATE CHECKED / UNCHECKED ARRAYS (NEW STRUCTURE)
  updateCheckedArrays(nodeId: string, isChecked: boolean) {
    const assetId = this.selectedEventCategoryAssetId;
    const assetTypeId = this.getAssetObj(this.selectedEventCategoryData?.assetType);

    const assetState = this.getAssetState(assetId, assetTypeId);

    if (isChecked) {
      if (!assetState.includeFolderNodeIds.includes(nodeId)) {
        assetState.includeFolderNodeIds.push(nodeId);
      }

      assetState.excludeFolderNodeIds =
        assetState.excludeFolderNodeIds.filter((id) => id !== nodeId);

    } else {
      if (!assetState.excludeFolderNodeIds.includes(nodeId)) {
        assetState.excludeFolderNodeIds.push(nodeId);
      }

      assetState.includeFolderNodeIds =
        assetState.includeFolderNodeIds.filter((id) => id !== nodeId);
    }
  }

  // ✅ CHECK ALL CHILDREN
  checkAllChildren(node: any, isChecked: boolean) {
    node.subChild.forEach((child: any) => {
      child.show_in_oil = isChecked;

      this.updateCheckedArrays(child.id, isChecked);

      if (child.subChild && child.subChild.length > 0) {
        this.checkAllChildren(child, isChecked);
      }
    });
  }

  // ✅ CHECK PARENT
  checkParent(parentID: string, allNodes: any[]) {
    const parent = allNodes.find((n: any) => n.id === parentID);

    if (parent && parent.isChecked !== 'true') {
      parent.isChecked = 'true';

      this.updateCheckedArrays(parent.id, true);

      if (parent.parentID) {
        this.checkParent(parent.parentID, allNodes);
      }
    }
  }

  // ✅ UPDATE PARENT STATE
  updateParentState(parentId: string, allNodes: any[]) {
    const parent = allNodes.find((n: any) => n.id === parentId);
    if (!parent || !parent.subChild) return;

    const visibleChildren = parent.subChild;

    const allChecked = visibleChildren.every((c) => c.show_in_oil);
    const allUnchecked = visibleChildren.every((c) => !c.show_in_oil);

    const assetState = this.getAssetState(
      this.selectedEventCategoryAssetId,
      this.getAssetObj(this.selectedEventCategoryData?.assetType)
    );

    if (allChecked) {
      parent.show_in_oil = true;
      this.updateCheckedArrays(parent.id, true);

    } else if (allUnchecked) {
      parent.show_in_oil = false;
      this.updateCheckedArrays(parent.id, false);

    } else {
      parent.show_in_oil = false;

      assetState.includeFolderNodeIds =
        assetState.includeFolderNodeIds.filter((id) => id !== parent.id);

      assetState.excludeFolderNodeIds =
        assetState.excludeFolderNodeIds.filter((id) => id !== parent.id);
    }

    if (parent.parentId) {
      this.updateParentState(parent.parentId, allNodes);
    }
  }

    getAssetObj(type) {
      const assetTypeObj = [
    { assetsTypeName: 'Aircraft', assetTypeId: '1' },
    { assetsTypeName: 'Engine', assetTypeId: '2' },
    { assetsTypeName: 'APU', assetTypeId: '3' },
    { assetsTypeName: 'Landing Gear', assetTypeId: '4' },
    { assetsTypeName: 'Propeller', assetTypeId: '5' },
    { assetsTypeName: 'Component', assetTypeId: '6' },
  ]
    return assetTypeObj.find(res => res.assetsTypeName?.toLowerCase() === type?.toLowerCase())?.assetTypeId
  }

   public setTreeView(): void {
    // Reset specific type arrays
    this.docTypeViewList = [];
    // Set static asset types

    // Build tree for each document
    for (const key in this.documentTypeList) {
      if (this.documentTypeList.hasOwnProperty(key)) {
        const rootNode = this.documentTypeList[key];
        const tree = this.convertToTree(rootNode, rootNode.assetTypeId); // recursion begins
        this.docTypeViewList.push(tree);
      }
    }

    // Assign to tree components
    this.documentTypeFields = { dataSource: this.docTypeViewList, id: 'tableId', text: 'name', child: 'subChild' };

  }
  private convertToTree(node: any, assetTypeId: string, parentPrefix: string = ''): any {
    const treeNode = {
      id: node.id,
      tableId: this.generateUniqueId(),
      name: this.buildPrefixFromPath(node.fullPath) + ' ' + this.removeFirstWord(node.name),
      text: this.buildPrefixFromPath(node.fullPath) + ' ' + this.removeFirstWord(node.name),
      prefix: node.id,
      assetTypeID: assetTypeId,
      label: 'folder',
      subChild: [],
      fullPath: node.fullPath,
      assetsTypePrefixs: node.name.split(' ')[0],
      folderCategoryName: node.name,
      parentId: node?.parentId,
      show_in_oil: true,
      doc_count:node?.doc_count
    };

    if (node.children && typeof node.children === 'object') {
      for (const key in node.children) {
        if (node.children.hasOwnProperty(key)) {
          const childNode = this.convertToTree(node.children[key], assetTypeId, node.name);
          treeNode.subChild.push(childNode); // recursion happens here
        }
      }
    }

    return treeNode;
  }
  buildPrefixFromPath(path: string, condition?: string): string {
    const segments = path?.split('/');
    const prefixParts: string[] = [];

    for (let i = 0; i < segments.length; i++) {
      const segment = segments[i].trim();
      if (!segment) continue;

      const firstWord = segment.split(' ')[0];

      if (i === 0) {
        // Always include the first word from the first segment
        prefixParts.push(firstWord);
      } else {
        // Include only if it's numeric
        if (/^\d+$/.test(firstWord)) {
          prefixParts.push(firstWord);
        }
      }
    }

    // Join segments with '.' while ensuring:
    // - no extra dots if a segment already ends with dot
    // - no trailing dot at the end
    return prefixParts
      .map((word, index) => {
        if (segments?.length === 1 && condition === 'file') {
          return word.slice(0, -1);
        }
        const isLast = prefixParts.length == 1 ? false : index === prefixParts.length - 1;
        return word.endsWith('.') ? word.slice(0, -1) + (isLast ? '' : '.') : word + (isLast ? '' : '.');
      })
      .join('');
  }
  generateUniqueId(): string {
    return 'id-' + Date.now() + '-' + Math.floor(Math.random() * 10000);
  }
  removeFirstWord(segment: string): string {
    const words = segment.trim().split(' ');
    return words.slice(1).join(' ');
  }
  public getDocTypeView(assetId?:any,assetTypeId?:any): void {
    try {
      this.documentTypeList = [];
      this.documentTypeFields = {};

      (this.docTypeSub = this.apiService
        .getDocTypeEventPermissionViewForAddEvent({
          assetTypeID: assetTypeId,
          assetId: assetId,
        })
        .subscribe(
          (data) => {
            this.documentTypeList = data;
            this.setTreeView();
          },
          (err) => {
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
          }
        )),
        (err) => {
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        };
    } catch (err) {
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    }
  }

  async viewDoc(assetTypeId, args) {
      console.log(assetTypeId, args);
      const modal = await this.modalController.create({
        component: AssetDocumentsComponent,
        cssClass: 'event-category-model',
        componentProps: {
          assetSN: this.selectedEventCategoryData?.serialNumber,
          assetType: assetTypeId,
          assetId: this.selectedEventCategoryAssetId,
          isAdmin: false,
          client: this.client,
          folderNodeId: args?.id,
          eventId: this.eventId,
        },
      });
      await modal.present();
      modal.onDidDismiss().then((result) => {
        if (result.data && result.data.dismissed) {
          // Refresh document list or perform another action
        }
      });
    }
  //   public getTaskListView(): void {
  //   try {

  //     (this.docTypeSub = this.apiService.getTaskListEventView(null, { assetTypeID: this.getAssetObj(this.selectedEventCategoryData?.assetType), assetId: this.selectedEventCategoryData?.id }).subscribe(
  //       (data) => {
  //         this.taskListState.push({...data})
  //       },
  //       (err) => {
  //         this.apiService.openErrorSnackBar(
  //           err?.error?.error ? err?.error?.error : 'Please contact support team',
  //           null
  //         );
  //       }
  //     )),
  //       (err) => {
  //         this.apiService.openErrorSnackBar(
  //           err?.error?.error ? err?.error?.error : 'Please contact support team',
  //           null
  //         );
  //       };
  //   } catch (err) {
  //     this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
  //   }
  // }

 TaskListValueChange(key: string, event: any) {
  const isChecked = event.checked;

  const assetId = this.selectedEventCategoryAssetId;
  const assetTypeId = this.getAssetObj(this.selectedEventCategoryData?.assetType);

  // ✅ get or create asset-specific object
  const assetState = this.getTaskListState(assetId, assetTypeId);

  // ✅ update value
  assetState[key] = isChecked;

  console.log('TaskList State:', this.taskListState);
}

  getTaskListState(assetId: string, assetTypeId: string) {
  let assetObj = this.taskListState.find(
    (x) => x.assetId === assetId && x.assetTypeId === assetTypeId
  );

  if (!assetObj) {
    assetObj = {
      assetId,
      assetTypeId,
        mpd: true,
        sb_mod: true,
        rd: true,
        awd: true
    };

    this.taskListState.push(assetObj);
  }

  return assetObj;
}
public async openEventTaskListViewModel(type: string): Promise<void> {
    const modal = await this.modalController.create({
      component: AirAdPage,
      cssClass: 'event-category-model',
      componentProps: {
        data: {
          assetTypeId: this.getAssetObj(this.selectedEventCategoryData?.assetType),
          msn: this.selectedEventCategoryData?.serialNumber,
          manufacturer: null,
          assetName: 'aircraft',
          task: type,
        },
        isModel: true,
        assetId: this.selectedEventCategoryAssetId,

      },
    });
    await modal.present();
    modal.onDidDismiss().then((result) => {
      if (result.data && result.data.dismissed) {
        if (result.data?.type === 'document') {
          this.getDocTypeView(this.eventId);
        } else {
          // this.getTaskListView();
        }
        // Refresh document list or perform another action
      }
    });
  }

  eventCategoryData(event){
    this.getOilEventDashboardData(event?.value,this.eventForm.get('assetTypeId').value)
  }
  DataOnExpendedRow(e:any){
    this.selectedEventCategoryAssetId = e?.data?.id;
  }

  onRowExpanding(e: any) {
    // Get the clicked row element
    const tr = this.parentsUntil(e.target as HTMLElement, 'e-row');

    // Ignore clicks inside detail row (child)
    if (tr && tr.classList.contains('e-detailrow')) {
      return; // Stop if clicked inside a child detail row
    }

    // Get the actual row index
    const trIdx = tr ? parseInt(tr.getAttribute('aria-rowindex') || '0') : null;
    if (trIdx === null) return;

    // Toggle expand/collapse logic
    if (this.expandedRowIndex !== trIdx) {
      if (this.expandedRowIndex !== null) {
        this.grid.detailRowModule.collapse(this.expandedRowIndex);
      }
      this.expandedRowIndex = trIdx;
      this.getDocTypeView(this.selectedEventCategoryAssetId,this.getAssetObj(this.selectedEventCategoryData?.assetType))
    } else {
      this.grid.detailRowModule.collapse(trIdx);
      this.expandedRowIndex = null;
    }

  }
  parentsUntil(element: HTMLElement, className: string): HTMLElement | null {
    while (element && !element.classList.contains(className)) {
      element = element.parentElement!;
    }
    return element;
  }

}
